// Client-side product-catalogue helper. Backend is authoritative for prices;
// this only caches shape/labels for UI. Never used to compute checkout amount.
import { api } from "./api";

let _cache = null;
let _pending = null;

export async function loadProducts() {
  if (_cache) return _cache;
  if (_pending) return _pending;
  _pending = api.get("/products").then((r) => {
    _cache = r.data;
    return _cache;
  }).catch(() => {
    _cache = { products: [], cashfreeMode: "unknown", paymentsLive: false };
    return _cache;
  }).finally(() => { _pending = null; });
  return _pending;
}

// Static CTAs — mirrors the CTO directive strings exactly.
export const CTA = {
  FIT_CHECK_FREE: "Start Free AI College Fit Check",
  REGRET_RISK_99: "Get My ₹99 College Regret Risk Report",
  EXPERT_CALL_499: "Book Expert Admission Call – ₹499",
  DECISION_PACK_999: "Get My Admission Decision Pack – ₹999",
  COLLEGE_GUIDANCE: "Get Admission Guidance for This College",
  WHATSAPP: "Chat on WhatsApp",
};

export const ROUTE = {
  FIT_CHECK_FREE: "/ai-counseling",
  REGRET_RISK_99: "/products/regret-risk-report",
  EXPERT_CALL_499: "/products/expert-call",
  DECISION_PACK_999: "/products/decision-pack",
  PRICING: "/pricing",
};
